import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  leftAlign: { textAlign: 'left' },
  textButton: {
    textDecoration: 'underline',
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
}));
